import { SetBuyReturnLabelActionStep } from "@redotech/redo-model/advanced-flow/oms/actions";
import { RedoToggle } from "@redotech/redo-web/arbiter-components/toggle/redo-toggle";
import { memo } from "react";
import { PartialWithRequiredType } from ".";

export const BuyReturnLabelToggle = memo(function BuyReturnLabelToggle({
  step,
  setStep,
}: {
  step: PartialWithRequiredType<SetBuyReturnLabelActionStep>;
  setStep: (step: PartialWithRequiredType<SetBuyReturnLabelActionStep>) => void;
}) {
  return (
    <RedoToggle
      label="Create prepaid return label"
      setValue={(value) => setStep({ ...step, buyReturnLabel: value })}
      size="xs"
      value={step.buyReturnLabel ?? false}
    />
  );
});
